import { render } from "./NavProfilMenu.vue?vue&type=template&id=72fa492b&scoped=true"
import script from "./NavProfilMenu.vue?vue&type=script&lang=js"
export * from "./NavProfilMenu.vue?vue&type=script&lang=js"

import "./NavProfilMenu.vue?vue&type=style&index=0&id=72fa492b&lang=scss&scoped=true"
import "./NavProfilMenu.vue?vue&type=style&index=1&id=72fa492b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fa492b"]])

export default __exports__